import React from 'react';
import { connect } from "react-redux";
import {getbookpayment} from '../../store/actions/book.js';


import { 
    Box, 
    FormControl, 
    Grid, 
    TextField, 
    Typography,
    FormHelperText
} from '@mui/material';

const  BookPaymentDetailsComponent = ({
    getBookPaymentDetails,
    setBookPaymentDetails,
    total,
}) => {
    // const ErrorInitialState = {
    //     error: false,
    //     message:""
    // }
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const handlebookEmail = (event) => {
      const email = event.target.value.trim().toLowerCase();
    
      setBookPaymentDetails((draft) => {
        draft.bookUserEmail.value = email;
    
        if (emailRegex.test(email)) {
          draft.bookUserEmail.isValid = true; // Mark as valid
          draft.bookUserEmail.error = ""; // Clear error message
        } else {
          draft.bookUserEmail.isValid = false; // Mark as invalid
          draft.bookUserEmail.error = "Invalid email format"; // Set error message
        }
      });
    };

    const handlebookComments = (event) => {
        const Comments = event.target.value;
        setBookPaymentDetails((draft) => {
            draft.bookUserComments.value = Comments;
            // Validate only if comments exceed 120 characters
            draft.bookUserComments.isValid = Comments.length <= 120;
          });
    }

    

  return (
    <>
        <Box
            className='puja-confirmation'
            component="form"
            sx={{
            '& .MuiTextField-root': { m: 1 },
            mx: 20,
            pt: 6
            }}
            noValidate
            autoComplete="off"
        >
            <div>
                <Box sx={{ mb: 4 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Box>
                                <label>Amount Paid</label>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Typography sx={{ color: '#8E8E8E' }}>
                            {Number(total).toFixed(2)}
                          </Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ mb: 4 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Box>
                                <label>Payment RER/UTR</label>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            {/* <FormControl fullWidth>
                                <TextField id="outlined-basic" variant="outlined"  />
                            </FormControl> */}
                            <Typography sx={{ color: '#8E8E8E' }}>{getBookPaymentDetails.OrderID.value}</Typography>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ mb: 4 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Box>
                                <label>Your Email ID <span className='label-required'>*</span></label>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <FormControl fullWidth>
                                <TextField 
                                id="outlined-basic" 
                                variant="outlined" 
                                value = {getBookPaymentDetails.bookUserEmail.value} 
                                onChange={handlebookEmail} 
                                />
                                 {!getBookPaymentDetails.bookUserEmail.isValid && (
                                 <FormHelperText error>
                                 {getBookPaymentDetails.bookUserEmail.errorMessage}
                                 </FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ mb: 4 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Box>
                                <label>Comments</label>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <FormControl fullWidth>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    multiline
                                    rows={4}
                                    value={getBookPaymentDetails.bookUserComments.value}
                                    onChange={handlebookComments}
                                    error = {!getBookPaymentDetails.bookUserComments.isValid}
                                />
                                <span>{getBookPaymentDetails.bookUserComments.value.length}/120</span>
                                {
                                !getBookPaymentDetails.bookUserComments.isValid && (
                                <FormHelperText error>
                                {getBookPaymentDetails.bookUserComments.errorMessage}
                                </FormHelperText>
                                )
                                }
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </div>
        </Box>
    </>
  )
 }
 const mapStateToProps = (state) => {
    return {
        bookPaymentDetails : state.book.bookPaymentDetails
    };
}

export default connect(mapStateToProps,{
    getbookpayment
    
  })(BookPaymentDetailsComponent);